import { createAction, handleActions } from 'redux-actions';
import { createContext, useContext } from 'react';
import { Location, History } from 'history';
import { useRedux } from 'util/hook/redux';

import history from 'store/history';
import { State as GlobalState } from './reducers';

export const routeChange = createAction<Location, Location>(
	'ROUTE_LOCATION_CHANGE',
	(location: Location) => location,
);

export type State = Location;

export const defaultState: State = { ...history.location };

export const reducer = {
	routing: handleActions<Location, Location>(
		{
			ROUTE_LOCATION_CHANGE: (state, action) => ({
				...state,
				...action.payload,
			}),
		},
		defaultState,
	),
};

export const HistoryContext = createContext<History>(history);

export const useHistory = (): History => useContext(HistoryContext);

const routeSelector = (state: GlobalState) => ({
	routing: state.routing,
});

const routeActionsMap = {};

type RouteSelector = ReturnType<typeof routeSelector>;
type RouteActionsMap = typeof routeActionsMap;

export const useRouting = () =>
	useRedux<RouteSelector, RouteActionsMap>(routeSelector, routeActionsMap);
